module.exports = __webpack_public_path__ + "img/logo-ajuntament-barcelona-rounded.430d97a2.svg";